import React, { useContext,useMemo } from "react";
import GoogleMapReact from "google-map-react";
import LocationMarker from "./LocationMarker";
import InterestContext from "../../context/interest/interestContext";

const Map = ({ center, zoom, sites, zipCoordinates }) => {
  const interestContext = useContext(InterestContext);
  const {
    learningCenterCoordinates,
    formData: { learningCenterName },
  } = interestContext;

  const dedupedSites = useMemo(() => {                   
    const seen = new Set();
    return sites.filter((s) => {
      if (!s?.coordinates) return false;
      const key = `${s.coordinates.latitude.toFixed(5)},${s.coordinates.longitude.toFixed(5)}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }, [sites]);

  const getListCenter = (list) => {
    if (list.length === 0) return center;
    const total = list.reduce(
      (acc, s) => ({
        lat: acc.lat + s.coordinates.latitude / list.length,
        lng: acc.lng + s.coordinates.longitude / list.length,
      }),
      { lat: 0, lng: 0 }
    );
    return total;
  };


  const mapCenter =
    dedupedSites.length > 0                              
      ? learningCenterName
        ? {
            lat: learningCenterCoordinates.latitude,
            lng: learningCenterCoordinates.longitude,
          }
        : getListCenter(dedupedSites)                     
      : center;


  const mapZoom =
    dedupedSites.length > 0                               
      ? learningCenterName
        ? 12
        : 7
      : zoom;


  const markers = sites.map((site) => {
    return (
      <LocationMarker
        lat={site.coordinates.latitude}
        lng={site.coordinates.longitude}
        site={site}
      />
    );
  });
  return (
    <div className="map" style={{borderRadius:'15px',overflow: 'hidden' ,background:'#F7F3EC'}}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyCRKw4Rdkoy0Q9rGgVrptXg0xrh5LRCd3Y" }}
        defaultCenter={center}
        defaultZoom={zoom} 
        center={mapCenter}
        zoom={mapZoom}       
      >
        {markers}
      </GoogleMapReact>
    </div>
  );
};

Map.defaultProps = {
  center: {
    lat: 34.6673486,
    lng: -118.1303682,
  },
  zoom: 4,
};

export default Map;
